<template>
	<div class="card" :class="'score-'+color">
		<div class="image"></div>
		<div class="score">{{score}}</div>
		<div class="label">Punti Totali</div>
		<div class="counter">
			<span class="value">{{currentWord+1}}</span>
			<span class="separator">/</span>
			<span class="value">{{wordsPerGame}}</span>
		</div>
	</div>
</template>

<script>
export default {
	props: ['score', 'index', 'words','currentWord','wordsPerGame','color'],
}
</script>
<style scoped lang="scss">
	.card {
		background: $mondadori-blue;
		border-radius: px(20);
		display: inline-block;
		width: 100%;
		height: px(80);
		position: relative;
		display: flex;
		align-items: center;
		@include breakpoint(s) {
			float: right;
			right: 1rem;
			width: 70%;
			padding-right: 1.5rem;
			height: px(50);
		}
		
		@include breakpoint(xs) {
			width: 50%;
		}

		&.score-orange .image{
			background-image: url(../assets/score-orange.svg);
		}

		&.score-pink .image {
			background-image: url(../assets/score-pink.svg);
		}

		.image {
			background-repeat: no-repeat;
			background-size: contain;
			background-position: center center;
			display: inline-block;
			width: px(100);
			height: 150%;
			@include breakpoint(xs) {
				display: none;
			}
		}
		.score {
			font-size: px(50);
			color: $mondadori-yellow;
			width: px(130);
			text-align: right;

		}
		.label {
			line-height: 1;
			padding-left: px(5);
			width: px(30);
			font-size: px(14);
			color: #fff;
			text-transform: uppercase;
		}
		.counter {
			position: absolute;
			top: 10%;
			right: 0;
			background: $mondadori-yellow;
			color: $mondadori-blue;
			font-size: px(14);
			padding: px(2) px(6);
			border-radius: px(10);
			transform: translate(50%, -50%);
		}
	}
	
</style>